module.exports = __webpack_public_path__ + "media/images/favicon-f70ea3a448f8e39ccaf6263d2ee77581.ico";